import { StoreData } from 'store/root-reducer';

export const selectUser = (state: StoreData) => state.userData.user;
